import React from 'react'
import ReactApexChart from "react-apexcharts";
import useReactApexChart from "../../hook/useReactApexChart";
const UserDetails = ({ users }) => {
    let { expenseStatisticsOptions, expenseStatisticsSeries } = useReactApexChart();
    
  return (
    <div className="">
      <div className="card radius-16 h-100">
        <div className="card-header">
          <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
            <h6 className="mb-2 fw-bold text-lg mb-0">Users Overview</h6>
          
          </div>
        </div>
        <div className="card-body">
          <div
            id="expenseStatistics"
            className="apexcharts-tooltip-z-none d-flex justify-content-center"
          >
            <ReactApexChart
              options={expenseStatisticsOptions}
              series={users}
              type="pie"
              height={540}
              width={420}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserDetails